import request from '@/utils/request'
import API from '@/api/base'
import { getTrackingKey } from '@/utils/api'

class CheckoutConfigurationAPI extends API {
  fetch = ({ countryCode, checkoutId }) => {
    return request(
      {
        method: 'GET',
        trackingKey: getTrackingKey(this.uri),
        path: this.uri,
        data: { country: countryCode, checkout_id: checkoutId },
      },
      { options: { attachToken: false, headers: { 'x-country': countryCode } } }
    )
  }
}
export default new CheckoutConfigurationAPI('/checkout/configuration')
